export const HELLOWORLD = [
  {
    _id: '609a5aed6c4d5f29aefa65ca',
    name: 'Hello World',
    owner: 'joem',
    url: '',
    private: false,
    snippets: [
      {
        _id: '609a522f6f98dca451e4feb3',
        title: 'C',
        filename: 'helloworld.c',
        description: "It's me, C.",
        language: 'c',
        value:
          '#include \n \nint main(void)\n{\n    puts("Hello, world!");\n}',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['c', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52306f98dca451e4feb4',
        title: 'C++',
        filename: 'helloworld.cpp',
        description: "It's me, C++.",
        language: 'cpp',
        value:
          '#include \n \nint main()\n{\n    std::cout << "Hello, world!\n";\n    return 0;\n}',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['c++', 'cpp', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52306f98dca451e4feb5',
        title: 'C#',
        filename: 'helloworld.cs',
        description: "It's me, C#.",
        language: 'csharp',
        value:
          '#include \nusing System;\nclass Program\n{\n    public static void Main(string[] args)\n    {\n        Console.WriteLine("Hello, world!");\n    }\n}',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['C#', 'csharp', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52316f98dca451e4feb6',
        title: 'Java',
        filename: 'helloworld.java',
        description: "It's me, Java.",
        language: 'java',
        value:
          'import javax.swing.JFrame;  //Importing class JFrame\nimport javax.swing.JLabel;  //Importing class JLabel\npublic class HelloWorld {\n    public static void main(String[] args) {\n        JFrame frame = new JFrame();           //Creating frame\n        frame.setTitle("Hi!");                 //Setting title frame\n        frame.add(new JLabel("Hello, world!"));//Adding text to frame\n        frame.pack();                          //Setting size to smallest\n        frame.setLocationRelativeTo(null);     //Centering frame\n        frame.setVisible(true);                //Showing frame\n    }\n}',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['java', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52316f98dca451e4feb7',
        title: 'jQuery',
        filename: 'helloworld.js',
        description: "It's me, jQuery.",
        language: 'javascript',
        value: '$("body").append("Hello world!");',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['jquery', 'javascript', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52326f98dca451e4feb8',
        title: 'JavaScript',
        filename: 'helloworld.js',
        description: "It's me, JavaScript.",
        language: 'javascript',
        value: "document.write('Hello, world!');",
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['javascript', 'ecmascript', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52326f98dca451e4feb9',
        title: 'Julia',
        filename: 'helloworld.jl',
        description: "It's Julia.",
        language: 'julia',
        value: 'println("Hello world!")',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['julia', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52326f98dca451e4feba',
        title: 'MatLab',
        filename: 'helloworld.matlab',
        description: "It's me, MatLab.",
        language: 'matlab',
        value:
          "classdef hello\n    methods\n        function greet(this)\n            disp('Hello, World')\n        end\n    end\nend",
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['matlab', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52336f98dca451e4febb',
        title: 'Pascal',
        filename: 'helloworld.cp',
        description: "It's me, Pascal.",
        language: 'pascal',
        value:
          "program HelloWorld;\nbegin\n  WriteLn('Hello, world!');\nend.",
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['pascal', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52336f98dca451e4febc',
        title: 'Python',
        filename: 'helloworld.py',
        description: "It's me, Python.",
        language: 'python',
        value: 'print "Hello, world!"',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['python', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52346f98dca451e4febd',
        title: 'R',
        filename: 'helloworld.r',
        description: "It's me, R.",
        language: 'r',
        value: "cat('Hello, world!\n')",
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['r', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52346f98dca451e4febe',
        title: 'Ruby',
        filename: 'helloworld.rb',
        description: "It's me, Ruby",
        language: 'ruby',
        value: 'puts "Hello, world!"',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['ruby', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
      },
      {
        _id: '609a52356f98dca451e4febf',
        title: 'Swift',
        filename: 'helloworld.swift',
        description: "It's me, Swift.",
        language: 'swift',
        value: 'println("Hello, world!")',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['swift', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52356f98dca451e4fec0',
        title: 'Visual Basic',
        filename: 'helloworld.vb',
        description: "It's me, Visual Basic.",
        language: 'visual-basic',
        value:
          'Module Module1\n    Sub Main()\n        Console.WriteLine("Hello, world!")\n    End Sub\nEnd Module',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['visual basic', 'net', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52366f98dca451e4fec1',
        title: 'CoffeeScript',
        filename: 'helloworld.coffee',
        description: "It's me, CoffeeScript.",
        language: 'coffeescript',
        value: "console.log 'Hello, world!'",
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['coffeescript', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        updatedOn: 'Tue, 11 May 2021 09:45:17 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c56f98dca451e4fec3',
        title: 'Eiffel',
        filename: 'helloworld.e',
        description: "It's me, Eiffel.",
        language: 'eiffel',
        value:
          'class\n    HELLO_WORLD\ncreate\n    make\nfeature\n    make\n        do\n            print ("Hello, world!%N")\n        end\nend',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['eiffel', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c56f98dca451e4fec4',
        title: 'Erlang',
        filename: 'helloworld.erl',
        description: "It's me, Erlang.",
        language: 'erlang',
        value:
          ' -module(hello).\n -export([hello_world/0]).\n\n hello_world() -> io:fwrite("hello, world\\n").',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['erlang', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c66f98dca451e4fec5',
        title: 'Elixir',
        filename: 'helloworld.ex',
        description: "It's me, Elixir.",
        language: 'elixir',
        value: 'IO.puts "Hello World!"',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['elixir', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c66f98dca451e4fec6',
        title: 'F#',
        filename: 'helloworld.fs',
        description: "It's me, F#.",
        language: 'fsharp',
        value: 'open System\nConsole.WriteLine("Hello World!")',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['f#', 'fsharp', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c76f98dca451e4fec7',
        title: 'Fortran',
        filename: 'helloworld.f90',
        description: "It's me, Fortran.",
        language: 'fortran',
        value:
          'program helloworld\n     print *, "Hello world!"\nend program helloworld',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['fortran', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c76f98dca451e4fec8',
        title: 'Go',
        filename: 'helloworld.go',
        description: "It's me, Go.",
        language: 'go',
        value:
          'package main\n\nimport "fmt"\n\nfunc main() {\n    fmt.Println("Hello, World")\n}',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['go', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c86f98dca451e4fec9',
        title: 'Groovy',
        filename: 'helloworld.groovy',
        description: "It's me, Groovy (Ruby).",
        language: 'groovy',
        value: 'println "Hello World"',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['groovy', 'ruby', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c86f98dca451e4feca',
        title: 'Logo',
        filename: 'helloworld.lgo',
        description: "It's me, Logo.",
        language: 'textfile',
        value: 'TO HELLO\n        PRINT [Hello world]\n        END',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['logo', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c96f98dca451e4fecb',
        title: 'Objective-C',
        filename: 'helloworld.m',
        description: "It's me, Objective-C.",
        language: 'objectivec',
        value: 'main()\n{\n  puts("Hello World!");\n  return 0;\n}',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['objectivec', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52c96f98dca451e4fecc',
        title: 'PowerShell',
        filename: 'helloworld.ps1',
        description: "It's me, PowerShell.",
        language: 'powershell',
        value: 'Write-Host "Hello, World!"',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['powershell', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52ca6f98dca451e4fecd',
        title: 'Rust',
        filename: 'helloworld.rs',
        description: "It's me, Rust.",
        language: 'rust',
        value: 'fn main() {\n    println!("Hello, world!");\n}',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['rust', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52ca6f98dca451e4fece',
        title: 'Scala',
        filename: 'helloworld.scala',
        description: "It's me, Scala.",
        language: 'scala',
        value:
          'object HelloWorld extends App {\n   println("Hello, World!")\n }',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['scala', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52cb6f98dca451e4fecf',
        title: 'Scheme',
        filename: 'helloworld.scm',
        description: "It's me, Scheme.",
        language: 'scheme',
        value:
          '(let ((hello0 (lambda() (display "Hello world") (newline))))\n  (hello0))',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['scheme', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52cb6f98dca451e4fed0',
        title: 'Scratch',
        filename: 'helloworld.js',
        description: "It's me, Scratch.",
        language: 'javascript',
        value: 'say Hello, World!',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['scratch', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52cc6f98dca451e4fed1',
        title: 'Tcl',
        filename: 'helloworld.tcl',
        description: "It's me, Tcl.",
        language: 'tcl',
        value: 'puts "Hello World!"',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['tcl', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52cc6f98dca451e4fed2',
        title: 'AppleScript',
        filename: 'helloworld.applescript',
        description: "It's me, AppleScript.",
        language: 'applescript',
        value: 'say "Hello, world!"',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['applescript', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52cd6f98dca451e4fed3',
        title: 'Assembly',
        filename: 'helloworld.asm',
        description: "It's me, Assembly Language.",
        language: 'asm6502',
        value:
          "    global  _main\n    extern  _printf\n\n    section .text\n_main:\n    push    message\n    call    _printf\n    add     esp, 4\n    ret\nmessage:\n    db  'Hello, World', 10, 0",
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['asm6502', 'assembly', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://julialang.org/learning/code-examples/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52cd6f98dca451e4fed4',
        title: 'OCaml',
        filename: 'helloworld.ml',
        description: "It's me, OCaml.",
        language: 'ocaml',
        value: 'print_endline "Hello, world!";;',
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['ocaml', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source:
          'https://excelwithbusiness.com/blog/say-hello-world-in-28-different-programming-languages/',
        score: 0,
        url: '',
      },
      {
        _id: '609a52ce6f98dca451e4fed5',
        title: 'Smalltalk',
        filename: 'helloworld.st',
        description: "It's me, Smalltalk.",
        language: 'smalltalk',
        value: "Transcript show: 'Hello World!'.",
        addedBy: 'joem',
        likedBy: ['chris', 'kate'],
        tags: ['smalltalk', 'hello world'],
        addedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        updatedOn: 'Tue, 11 May 2021 09:47:49 GMT',
        private: false,
        source: 'https://en.wikipedia.org/wiki/GNU_Smalltalk',
        score: 0,
        url: '',
      },
    ],
  },
];
